import React from "react";
import {StateSwitchComponent} from '../StateSwitchComponent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import 'chart.js/auto';
import CreateTable from '../CreateTable.jsx';
import { Radar } from 'react-chartjs-2';
import { Chart, Filler } from 'chart.js';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import { saveAs } from 'file-saver';
import Slider from '@mui/material/Slider';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { InputSwitch } from 'primereact/inputswitch';

import {
  List,
  ListItem,
  ListItemText,
  Divider,
  Collapse
} from "@material-ui/core";

const counter = {
  id: "counter",
  beforeDraw: (chart) => {
    const ctx = chart.canvas.getContext('2d');
    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  }
};

Chart.register(Filler, counter);

function sortBySimilarity(a, b) {
  if (a.similarity === -1) return 1;
  if (b.similarity === -1) return -1;
  return a.similarity - b.similarity;
}

function sortPlayers(players, sortType) {
  const next = [...players];
  if (sortType === "wAV") {
    next.sort((a, b) => b[sortType] - a[sortType]);
  } else {
    next.sort((a, b) => {
      if (a[sortType] === -1) return 1;
      if (b[sortType] === -1) return -1;
      return a[sortType] - b[sortType];
    });
  }
  return next;
}

function scoreToSimilarityPercent(score) {
  if (score == null || score === -1) return 0;
  const s = Number(score);
  if (Number.isNaN(s) || s < 0) return 0;
  return (100 / (1 + s)).toFixed(2);
}

function padOriginalInfo(originalinfo) {
  const traits = Array.isArray(originalinfo) ? [...originalinfo] : [];
  while (traits.length < 13) {
    traits.push('');
  }
  return traits.slice(0, 13);
}

function buildPlayersFromResponse(mainSiteComponent) {
  const playerInfo = mainSiteComponent.state.playerInfo;
  const ogPlayerName = mainSiteComponent.state.originalPlayerName;
  const nameMap = mainSiteComponent.state.nameMap;
  const playerPercentiles = mainSiteComponent.state.player_percentiles;
  const similarityPercents = mainSiteComponent.state.similarityPercents || {};

  return Object.keys(playerInfo).map((key, i) => {
    const row = playerInfo[key];
    return {
      id: String(i + 1),
      nameHeader: key,
      realName: nameMap[key],
      info: row.slice(0, -1),
      similarity: row.at(-1),
      similarityPercent: similarityPercents[key] != null
        ? similarityPercents[key]
        : scoreToSimilarityPercent(row.at(-1)),
      wAV: row.at(-2),
      round: row.at(-3),
      pickNumber: row.at(-4),
      data: {
        labels: ['Height', 'Weight', 'Hand Size', 'Arm Length', '40 Time',"Bench Press", "Vertical Leap", "Broad Jump", "Shuttle Time", "3 Cone"],
        datasets: [
          {
            label: key,
            data: playerPercentiles[key],
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            fill: true,
            borderWidth: 1,
          },
          {
            label: ogPlayerName,
            data: playerPercentiles[ogPlayerName],
            backgroundColor: 'rgba(100, 199, 255, 0.2)',
            borderColor: 'rgba(100, 199, 255, 1)',
            fill: true,
            borderWidth: 1,
          }
        ],
      }
    };
  }).sort(sortBySimilarity);
}

class ResultPage extends StateSwitchComponent {
  constructor(props){
    super(props);
    this.mainSiteComponent = props.mainSiteComponent;
    const basePlayers = buildPlayersFromResponse(this.mainSiteComponent);
    const settings = basePlayers.map((p) => ({ id: p.id, open: false }));

    this.state = {
      settings,
      checked: true,
      sortType: "similarity",
      minSimilarPercent: 0,
      basePlayers,
    };
    window.scrollTo(0, 0);
  }

  back = () => {
      this.mainSiteComponent.setState({view: 'search'})
  }

  saveImage(id){
   var chart = document.getElementById(id);
    chart.toBlob(function (blob) {
    saveAs(blob, id+".png")
  })
  }

  handleChange = (event) => {
    this.setState({checked: event.value})
  }

  handleMinSimilarChange = (event, value) => {
    this.setState({ minSimilarPercent: value })
  }

  handleSortChange = (event, value) => {
    if (value == null) return;
    this.setState({ sortType: value })
  }

  handleClick = id => {
    this.setState(state => ({
      ...state,
      settings: state.settings.map(item =>
        item.id === id ? { ...item, open: !item.open } : item
      )
    }));
  };

  getVisiblePlayers() {
    const { basePlayers, sortType, minSimilarPercent } = this.state;
    const sorted = sortPlayers(basePlayers, sortType);
    if (sortType === 'similarity') {
      return sorted;
    }
    return sorted.filter(
      (player) => Number(player.similarityPercent) > minSimilarPercent
    );
  }

  render() {
    const { settings } = this.state;
    const visiblePlayers = this.getVisiblePlayers();
    const paddedOriginalInfo = padOriginalInfo(this.mainSiteComponent.state.originalinfo);

    const graphOptions = { maintainAspectRatio: false,backgroundColor: '#5cc249',
      plugins: {
        legend: {
            labels: {
                font: {
                    size: 18
                }
            }
        }
    },
    scales: {
      gridLines: {
           display: false
         },
      r: {
      suggestedMax: 1,
      suggestedMin: 0,
      stepSize: 0.1,
        pointLabels: {
          font: {
            size: 16
          }
        }
      }
    }
    };
    return (
      <div style={{ marginRight: "15px" }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', p: 1, m:2, justifyContent: 'space-between'}}>
        <IconButton aria-label="delete" onClick={this.back}     style={{
          borderRadius: 35,
          fontSize: "24px",
          color : "#000000"}}>
          <ArrowBackIcon /> &nbsp; Back
        </IconButton>
        <Box sx = {{display: 'flex', flexDirection : 'column', p: 1, gap: 0.5, alignItems: 'center'}} >
        <Typography align = 'center' >
        Show Trait Table
        </Typography>
          <InputSwitch
               onChange={this.handleChange}
               checked={this.state.checked}/>
        </Box>
      </Box>
      <Typography variant="h6" align = 'center' >
      Click on a Name to Expand. Number to the Right is Percent Similar (100% = closest match). Values in the Radar Chart is the Percentile (e.g. 0.9 = top 10%).
      <br />
      <br />
      Choose an Option Below to Determine the Type of Sort
      </Typography>
        <ToggleButtonGroup
          color="primary"
          size="large"
          value={this.state.sortType}
          exclusive
          onChange={this.handleSortChange}
          style={{ display: 'flex', justifyContent: 'center'}}
          aria-label="Platform">
          <ToggleButton style={{ borderRadius: '5px', border: '1px solid #1565c0', padding: '10px 20px', textTransform: 'none'}} value="similarity">Similarity</ToggleButton>
          <ToggleButton style={{ borderRadius: '5px', border: '1px solid #1565c0', padding: '10px 20px', textTransform: 'none' }} value="pickNumber">Pick Number</ToggleButton>
          <ToggleButton style={{ borderRadius: '5px', border: '1px solid #1565c0', padding: '10px 20px', textTransform: 'none' }} value="wAV">Value (wAV)</ToggleButton>
        </ToggleButtonGroup>
        {this.state.sortType !== 'similarity' &&
          <div sx={{ p: 1, m: 2}}>
            <Typography variant="h6" align='center' >
              Filter by Minimum Percent Similar 
            </Typography>
            <Slider value={this.state.minSimilarPercent} min={0} max={100} valueLabelDisplay="on"
              onChange={this.handleMinSimilarChange}
              aria-label="Always visible"
            />
          </div>
        }
        {visiblePlayers.length === 0 && (
          <Typography variant="h6" align="center" sx={{ p: 2 }}>
            No matching players found.
          </Typography>
        )}
        <List component="nav">
          {visiblePlayers.map(each => (
            <React.Fragment key={each.id}>
              <ListItem button onClick={() => this.handleClick(each.id)}>
                <ListItemText inset primary={each.nameHeader}  primaryTypographyProps={{
                    color: 'primary',
                    fontWeight: 'medium',
                    variant: 'h5',
                    fontSize: 20,
                  }}/>
                  <Typography variant="h6" align = 'center' >
                  {this.state.sortType === 'wAV' ? (
                    <p>wAV: {each.wAV ? each.wAV : 0}</p>
                  ) : this.state.sortType === 'pickNumber' ? (
                    <p>Pick: {each.pickNumber === -1 ? 'UDFA' : each.pickNumber}</p>
                  ) : (
                    <p>Similarity: {Number(each.similarityPercent).toFixed(2)}%</p>
                  )}
                  </Typography>
              </ListItem>
              <Divider />
              <Collapse
                in={settings.find(item => item.id === each.id).open}
                timeout="auto"
                unmountOnExit>
              <IconButton aria-label="delete" onClick={()=>this.saveImage(each.nameHeader)} style={{
                borderRadius: 35,
                fontSize: "24px",
                color : "#000000"}}>
                <DownloadIcon /> Download Chart
              </IconButton>
              <Box sx={{ display: 'flex', flexDirection: 'row-reverse', p: 1, m:1 }}>
  {this.state.checked && <CreateTable  sx={{ flexGrow: 1 }} playerInfo={each.info} originalInfo = {paddedOriginalInfo} originalPlayerName = {this.mainSiteComponent.state.originalPlayerName} playerName = {each.realName}/>}
                <Radar data={each.data} options={graphOptions} id={each.nameHeader} height={800} weight ={800} />
                </Box>
              </Collapse>
            </React.Fragment>
          ))}
        </List>
      </div>
    );
  }
}
export default ResultPage;
